var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.document)?_c('BaseFileViewer',{attrs:{"title":_vm.document.title,"file-url":_vm.url,"type":_vm.extension,"dialog":true},on:{"input":_vm.onClose}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }